/**
 * Single source of truth for the public Discord invite.
 *
 * This was previously hardcoded in three places, which is how they drifted apart:
 * the footer pointed at `discord.gg/goonru` (a vanity URL that doesn't exist yet —
 * it returned "Unknown Invite", so the footer link was dead), while the early-access
 * modal and the house ad used a working personal invite code.
 *
 * This invite was created BY THE BOT (Glym), not by a person, so Discord's join splash
 * reads "Glym invited you to join" instead of naming a personal account. It never
 * expires and has unlimited uses.
 *
 * A vanity URL (discord.gg/goonru) would drop the inviter line entirely, but that needs
 * Level 2 boost (7 boosts) and the server is currently at tier 0. When it gets there,
 * change this one constant:
 *
 *   export const DISCORD_INVITE_URL = "https://discord.gg/goonru"
 */
export const DISCORD_INVITE_URL = "https://discord.gg/dxMmyaM3xb"
